/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/currencyFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoCustomNumeric implements angular.IDirective {
        restrict = "E";
        scope = {
            currentValue: "=ngModel",
            contentKey: "@",
            maxLength: "=",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            selectOnFocus: "@",
            minValue: "@",
            maxValue: "@",
            disableDecimals: "=?",
            decimalMask: "=?",
            postOnBlur: "&",
            ngChange: "&?",
            placeholder: "@",
            onEnter: "&",
            onFocus: "&",
            name: "@",
            completeWithZero: "=?",
            allowLeadingZeroes: "=?",
            tabIndex: "=?",
            rightAlign:"=?",
            changeValuesOnInit:"=?",
            formatNumber:"=?",
            isPercentage:"=?"
        };
        require = "ngModel";
        templateUrl = 'app/components/controls/customNumericTemplate.html';

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            let timeout = this.$timeout;
            let inputElem: any = element.find("input");
            let backspacePressed: boolean = false
            let minValue: number;
            let maxValue: number;
            let oldVal: string;

            if (angular.isUndefined(scope.decimalMask)) {
                scope.decimalMask = 2;
            }

            if (angular.isUndefined(scope.allowLeadingZeroes)) {
                scope.allowLeadingZeroes = true;
            }

            if (angular.isUndefined(scope.rightAlign) || (scope.rightAlign === "false")) {
                scope.rightAlign = false;
            } else {
                scope.rightAlign = true;
            }

            if (angular.isUndefined(scope.completeWithZero)) {
                scope.completeWithZero = false;
            }

            if (angular.isUndefined(scope.formatNumber)) {
                scope.formatNumber = false;
            }

            if (angular.isUndefined(scope.isPercentage)) {
                scope.isPercentage = false;
            }

            var hasMinValue = false;
            var hasMaxValue = true;

            if (_.isFinite(scope.minValue)) {
                minValue = +scope.minValue;
                hasMinValue = true;
            }
            
            if (_.isFinite(scope.maxValue)) {
                maxValue = +scope.maxValue;
            }
            
            scope.valueChanged = function () {
                if (scope.currentValue == undefined || scope.currentValue == null) {
                    scope.currentValue = '';
                }

                if (scope.isPercentage) {
                    if (scope.currentValue !== '' || scope.currentValue !== '%') {
                        let currentValue = scope.currentValue.replace(/%/g, '')
                        
                        if (isNaN(currentValue)) {
                            currentValue = oldVal.replace(/%/g, '');
                        }
                        if (backspacePressed) {
                            backspacePressed = false;
                            currentValue = currentValue.slice(0, -1);
                        }
                        if (!scope.allowLeadingZeroes) {
                            if (scope.decimalMask > 0 && currentValue.slice(-1) === '.') {
                                currentValue = Number(currentValue) + '.';
                            } else {
                                currentValue = Number(currentValue);
                            }
                        }
                        if (+currentValue > +maxValue) {
                            currentValue = maxValue;
                        }
                        scope.currentValue = currentValue + '%';
                    }
                } else {
                    if (scope.currentValue != '') {
                        if (isNaN(scope.currentValue)) {
                            scope.currentValue = oldVal;
                        }
                        if (!scope.allowLeadingZeroes) {
                            scope.currentValue = Number(scope.currentValue);
                        }
                        if (+scope.currentValue > +maxValue) {
                            scope.currentValue = maxValue;
                        }
                        scope.currentValue += '';
                    }
                }

                if (_.isFunction(scope.ngChange)) {
                    timeout(() => {
                        scope.ngChange();
                    });
                }
            }

            scope.onBlur = () => {
                if (scope.isPercentage) {
                    if (hasMinValue && (scope.currentValue.length === 1 || +('' + scope.currentValue).replace(/%/g, '') < +minValue)) {
                        ngModel.$setViewValue(minValue + '%');
                    }
                } else {
                    if (hasMinValue && (scope.currentValue.length == 0 || +scope.currentValue < +minValue)) {
                        ngModel.$setViewValue('' + minValue);
                    }
                }
                if (hasMaxValue && +scope.currentValue > +maxValue) {
                    ngModel.$setViewValue('' + maxValue);
                }

                if (scope.completeWithZero) {
                    ngModel.$setViewValue(Number(scope.currentValue).toFixed(scope.decimalMask));
                }

                scope.watchCurrentValue();

                if (_.isFunction(scope.postOnBlur)) {
                    scope.postOnBlur();
                }
            }

            var deregisterCurrentValueWatcher = null;
            scope.watchCurrentValue = () => {
                if (deregisterCurrentValueWatcher === null) {
                    deregisterCurrentValueWatcher = scope.$watch('currentValue', (newValue, oldValue, currentScope) => {
                        oldVal = newValue;
                    });
                }
            }
            scope.watchCurrentValue();

            element.on("click", (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    if (target.nodeName === "INPUT" && target.type === "text" && !!scope.selectOnFocus && scope.selectOnFocus.toLowerCase() === "true") {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

            element.on("keydown", (event: JQueryEventObject) => {
                backspacePressed = event.keyCode === 8;

                if (_.contains([46, 8, 9, 27, 13], event.keyCode) ||
                    // decimal keys (beside the comma key, and the numeric-pad key).  Check shift key to prevent >.  Don't allow multiple periods.
                    (!scope.disableDecimals && _.contains([110, 190], event.keyCode) && !event.shiftKey && scope.currentValue.toString().indexOf(".") === -1) ||
                    // Allow: Ctrl+A
                    (event.keyCode === 65 && event.ctrlKey) ||
                    // Allow: Ctrl+C
                    (event.keyCode === 67 && event.ctrlKey) ||
                    // Allow: Ctrl+X
                    (event.keyCode === 88 && event.ctrlKey) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39)) {

                    if (event.keyCode === 13 && _.isFunction(scope.onEnter)) {
                        scope.onEnter({ event: event });
                    }

                    // let it happen, don't do anything
                    return;
                }
                // Ensure that it is a number and stop the keypress
                if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }

                // Validate decimals
                let caret = (<HTMLInputElement>event.target).selectionStart;
                let currentValue = String(scope.currentValue || '');
                if (caret != undefined) {
                    let decimals = (currentValue.slice(0, caret) + event.key + currentValue.slice(caret, currentValue.length)).split('.')[1]
                    if (decimals) decimals = decimals.replace(/%/g, '');
                    if (!scope.completeWithZero && !scope.disableDecimals && Model.Guard.isSomething(decimals) && decimals.length > scope.decimalMask) {
                        event.preventDefault();
                    }
                }

                return true;
            });

            inputElem.focus((event: JQueryEventObject) => {
                if (deregisterCurrentValueWatcher !== null) {
                    deregisterCurrentValueWatcher();
                    deregisterCurrentValueWatcher = null;
                }
                if (_.isFunction(scope.onFocus)) {
                    scope.onFocus();
                    inputElem.val(scope.currentValue);
                    oldVal = scope.currentValue;
                }
            });

            inputElem.mouseup((event: BaseJQueryEventObject) => {
                window.setTimeout(function () {
                    var selectionEnd = inputElem[0].selectionEnd;
                    inputElem[0].setSelectionRange(0, selectionEnd);
                }, 100)

            });

            if (scope.changeValuesOnInit && !(scope.currentValue == undefined || scope.currentValue == null)) {
                ngModel.$setViewValue(Number(scope.currentValue).toFixed(scope.decimalMask));    
            }

            window.setTimeout(scope.format, 40)
        }

        constructor(private $timeout, private $filter) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout, $filter) => {
                return new MeevoCustomNumeric($timeout, $filter);
            };
            directive.$inject = ["$timeout", "$filter"];
            return directive;
        }

    }
    angular.module("meevo.components.controls")
        .directive("meevoCustomNumeric", MeevoCustomNumeric.factory());
}
